import { z } from '@harvestiq/zod';

export const livestockPolicyTypesSchema = z.object({
  'Fed Cattle': z.boolean().optional(),
  'Feeder Cattle': z.boolean().optional(),
  Swine: z.boolean().optional(),
  Cattle: z.boolean().optional(),
});
export type LivestockPolicyTypes = z.infer<typeof livestockPolicyTypesSchema>;

export const livestockCapacitySchema = z.object({
  'Fed Cattle': z.number().optional(),
  'Feeder Cattle': z.number().optional(),
  Swine: z.number().optional(),
  Cattle: z.number().optional(),
});
export type LivestockCapacity = z.infer<typeof livestockCapacitySchema>;
